import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mapbox: {
      accessToken: '',
      defaultOptions: {
        style: 'https://api.maptiler.com/maps/07b5cdb5-4155-4d87-91b0-165d53384fec/style.json?key=EiCgsIZ0YBbXRdNSx4X8',
      },
    },
    elementLinks: {
      createFolder: process.env.NODE_ENV === 'production'
        ? `http://element-iot.com/${localStorage.getItem('mandate_slug')}/tree/create_tag`
        : `//localhost:4000/${localStorage.getItem('mandate_slug')}/tree/create_tag`,
    },
    colors: {
      parkingSpace: {
        occupied: '#F44336',
        available: '#4CAF50',
      },
    },
  },
});
